
/* eslint-disable */
import { useEffect } from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ChatModule from "../Chat";
import { hasAuthority } from "../../../utils/authorities";
import Datatable from "../../components/features/Datatable";
import Filter from "./Filter";
import {
  getCoaFormCompleteList,
  selectcoaFormCompleteList,
} from "../../slices/qualityControl";
import {capitalizeWords} from "../../../utils/utils"
const filterConfig = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
  cycle: {
    label: "Cycle",
  },
};

const QualityControl = () => {
  const navigate = useNavigate();
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const dispatch = useDispatch();

  const qualityControlData = useSelector(selectcoaFormCompleteList);

  const tableData = {
    items: qualityControlData?.items || qualityControlData?.data || [],
    total_count:
      qualityControlData?.pageDetails?.total_count ||
      qualityControlData?.total_count ||
      0,
    page: qualityControlData?.pageDetails?.page || 1,
    per_page: qualityControlData?.pageDetails?.per_page || 10,
  };

  const handleServerSideChange = async (params) => {
    try {
      await dispatch(getCoaFormCompleteList(params));
    } catch (error) {
      console.error("Error fetching quality control data:", error);
    }
  };

  // Initial data fetch
  useEffect(() => {
    handleServerSideChange({ page: 1, per_page: 10 });
  }, []);

  const columns = [
    {
      id: "subject_code",
      name: "Subject/Patient ID",
      selector: (row) => (row.patient_id ? row.patient_id : "N/A"),
      sortable: true,
    },
    {
      id: "subject_name",
      name: "Subject/Patient Name",
      selector: (row) => (row.subject_name ? capitalizeWords(row.subject_name) : "N/A"),
      sortable: true,
    },
    {
      id: "product",
      name: "Product/Phase",
      selector: (row) =>
        row.product && row.phase ? `${(row.product)}/${capitalizeWords(row.phase)}` : "N/A",
      sortable: true,
    },
    {
      id: "phase_type",
      name: "Type",
      selector: (row) => (row.phase_type ? row.phase_type : "N/A"),
      sortable: true,
    },
    {
      id: "hospital_name",
      name: "Hospital/Site",
      selector: (row) => (row.hospital_name ? row.hospital_name : "N/A"),
      sortable: true,
    },
{
  id: "approval_status",
  name: "Approved Status",
  selector: (row) =>
    row.approval_status ? (
      row.approval_status === "Approved" ? (
        <p className="text-[#00B278] font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
          {row?.approval_status}
        </p>
      ) : row.approval_status === "Partially Approved" ? (
        <p className="text-[#F97316] font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
          {row?.approval_status}
        </p>
      ) : row.approval_status === "Rejected" ||
        row.approval_status === "Pending" ? (
        <p className="text-[#FF2023] font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
          {row?.approval_status}
        </p>
      ) : (
        <p className="text-gray-400 font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
          {row?.approval_status}
        </p>
      )
    ) : (
      "N/A"
    ),
  sortable: true,
},
 { id: "stage", name: "Stage", selector: row => row.stage ? row.stage : "N/A", sortable: true },

        {
    id: "cycleObject", 
    name: "Cycle",
    selector: (row) => {
        if (row.cycleObject) {
            const cycleValue =  row.cycleObject;
            return (
                <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium border border-blue-300 whitespace-nowrap">
                    {cycleValue}
                </span>
            );
        }
        return "N/A";
    },
    sortable: true,
},
    {
      name: "Action",
      selector: (row) => (
        <Button
          onClick={() => {
            const qrId = row?.qr_code_generated_id;
            const feasibilityId = row?.id;
            const coaFormId = row?.coa_form_id;

            navigate(`/bmr/qc/${qrId}/?batch=${row?.batch_no}`, {
                row: {
                  ...row,
                  product_id: row?.product_id,
                  product_manufacturing_id: row?.product_manufacturing_id,
                  mfg_date: row?.mfg_date,
                  expired_at: row?.expired_at,
                  batch_no: row?.batch_no,
                },
               state: [
              { name: "Quality Control", path: location.pathname },
              {
                name: "Details",
                path: `/bmr/qc/${qrId}/?batch=${row?.batch_no}`,
              },
            ],
              },
            );
          }}
          key={row?.subject_id}
          size="small"
          className="!w-[100px]"
        >
          View Details
        </Button>
      ),
    },
  ];

  return (
    <Grid
      container
      className="mt-4 ml-0 mr-3 mainDiv"
      rowSpacing={4.5}
      columnSpacing={2.75}
    >
      <Grid item xs={12} sx={{ mt: -2.25 }}>
        {hasAuthority(["quality-control-listing","quality-control-lead-approval-listing"], bmr_permissions) && (
          <div>
            <Datatable
              columns={columns}
              data={tableData}
              title="Subject/Patient"
              FilterComponent={Filter}
              onServerSideChange={handleServerSideChange}
              remote={true}
              filterConfig={filterConfig}
            />
            <ChatModule />
          </div>
        )}
      </Grid>
    </Grid>
  );
};

export default QualityControl;
